import { useCallback, useEffect, useState } from "react";
import { MaterialRequestStatus } from "features/MaterialRequests/constants/material-request.constants";
import { getMaterialRequests } from "features/MaterialRequests/services/MaterialRequestService";

export type UsePendingMaterialRequestCountResult = {
  count: number;
  isLoading: boolean;
  refetch: () => void;
};

export function usePendingMaterialRequestCount(
  enabled: boolean,
): UsePendingMaterialRequestCountResult {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [tick, setTick] = useState(0);

  const refetch = useCallback(() => {
    setTick((t) => t + 1);
  }, []);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    void (async () => {
      try {
        const res = await getMaterialRequests({
          page: 1,
          limit: 1,
          status: MaterialRequestStatus.REQUESTED,
        });
        if (cancelled) return;
        if (res.success && res.data) {
          const total = Number(res.data.totalItems);
          setCount(Number.isFinite(total) && total > 0 ? total : 0);
        } else {
          setCount(0);
        }
      } catch {
        if (!cancelled) setCount(0);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled, tick]);

  return { count, isLoading, refetch };
}
